// extracted by mini-css-extract-plugin
export default {"label":"AreaChart_label__+Q7VX"};